// Material
import { Typography, Button } from '@mui/material'
// Common
import { ArrowRightIcon } from '$common/icons'
// Localization
import { t } from '$i18n'

export function EditAccountBackButton({ onClick }: { onClick: () => unknown }) {
  return (
    <Button
      startIcon={<ArrowRightIcon sx={{ color: 'white' }} />}
      onClick={onClick}
    >
      <Typography color="white" variant="subtitle3">
        {t('myAccountEdit.return')}
      </Typography>
    </Button>
  )
}
